import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import PreservedPage from './components/PreservedPage'
import CommunityPage from './pages/CommunityPage'
import NotFoundPage from './pages/NotFoundPage'

type PreservedPageName = 'home' | 'demo' | 'integrations' | 'about'

const routeForPage: Record<string, string> = {
  home: '/',
  demo: '/demo',
  integrations: '/integrations',
  about: '/about',
}

const preservedRoutes: Record<string, { page: PreservedPageName; title: string }> = {
  '/': { page: 'home', title: 'Road Stack home' },
  '/demo': { page: 'demo', title: 'Road Stack interactive cockpit demo' },
  '/integrations': { page: 'integrations', title: 'Road Stack integrations' },
  '/about': { page: 'about', title: 'About Road Stack' },
}

function App() {
  const location = useLocation()
  const navigate = useNavigate()
  const preservedRoute = preservedRoutes[location.pathname]

  useEffect(() => {
    const handleDesignNavigation = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return
      if (event.data?.type !== 'roadstack:navigate') return
      const destination = routeForPage[event.data.page]
      if (destination) navigate(destination)
    }

    window.addEventListener('message', handleDesignNavigation)
    return () => window.removeEventListener('message', handleDesignNavigation)
  }, [navigate])

  if (preservedRoute) {
    return <PreservedPage page={preservedRoute.page} title={preservedRoute.title} />
  }

  return (
    <Routes>
      <Route path="/community" element={<CommunityPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default App
